import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'
import { useFirstVisit } from 'utils/hooks/useFirstVisit'
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip/Tooltip'

export const FirstVisitTooltip = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const t = useTranslations('TravelMagazine.Search')
  const isFirstVisit = useFirstVisit()
  const [tooltipOpen, setTooltipOpen] = useState(false)

  useEffect(() => {
    setTooltipOpen(isFirstVisit)
  }, [isFirstVisit])

  return (
    <Tooltip open={tooltipOpen} showArrow>
      <TooltipTrigger asChild className='lg:hidden'>
        {children}
      </TooltipTrigger>
      <TooltipContent
        className='-top-4 !h-[67px] !w-[177px] lg:hidden'
        onEscapeKeyDown={() => setTooltipOpen(false)}
        onPointerDownOutside={() => setTooltipOpen(false)}
      >
        <div data-testid='first-visit-tooltip-content'>
          {t('tooltipContent')}
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
